__turbopack_context__.v({
  "className": "geist_7bec2a75-module__onArlW__className",
  "variable": "geist_7bec2a75-module__onArlW__variable",
});
